import React from 'react'

export default function PrivacyContent(): JSX.Element {
  // TODO if user is not an admin, then 403 or redirect
  return (
    <div>
      {/* Placeholder for privacy content */}
      <p>Privacy Content</p>
    </div>
  )
}
